// extracted by mini-css-extract-plugin
export var discard = "_3f-3";
export var muiTooltipTooltip = "_3f-5";
export var notificationBar = "_3f-2";
export var saveButtonHoverSlotWrapper = "_3f-4";
export var show = "_3f-1";
export var spacer = "_3f-0";